<template>
    <div class="dataStatistics mam-sub border-radius5 white mar-bot10">
        <el-row class="">
            <el-col :lg="6" :md="6" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Total_subscription_revenue')}}</div>
                <div
                        class="data color-span"
                        :class="{on: !isIncludeMinus(dataStatistics.statProfit)}"
                >{{dataStatistics.statProfit}}</div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Subscription_yield')}}</div>
                <div
                        class="data color-span"
                        :class="{on: ! isIncludeMinus(dataStatistics.earningRate)}"
                >{{dataStatistics.earningRate}}</div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('Average_billing_cycle')}}</div>
                <div
                        class="data"

                >{{dataStatistics.averageDays}}{{$t('day')}}</div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('contractDetailed.tradingHour')}}</div>
                <div class="data">{{dataStatistics.times}}{{$t('day')}}</div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { isIncludeMinus } from '@/utils/common'
  export default {
    name: 'dataStatisticsMamMaster',
    props: {
      dataStatistics: {
        type: Object,
        default() {
          return {
            statProfit: '',
            earningRate: '',
            averageDays: '',
            times: '',
          }
        }
      }
    },
    methods: {
      isIncludeMinus
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../../../../../assets/scss/variable";
.dataStatistics {
    .text {
        font-size: 14px;
        color: #999999;
        margin-bottom: 10px;
    }
    .data {
        font-size: 20px;
        color: #333333;
        font-weight: bold;

    }
    .color-span {
        color: $themeColor;
        &.on {
            color: $themeGreen;
        }
    }
}
</style>
